import { Box, Button } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import React = require('react');

type SubmitButtonProps = {
  isDisabled: boolean;
  isLoading?: boolean;
};

export const SubmitButton: React.FC<SubmitButtonProps> = ({ isDisabled, isLoading = false }) => {
  return (
    <Button
      isDisabled={isDisabled}
      isLoading={isLoading}
      type="submit"
      rightIcon={<Icon icon="chevron-right" />}
      leftIcon={<Box w={'16px'} />}
      height={'60px'}
      justifyContent="space-between"
      width={['full']}
      minWidth={['full', 'full', 'full', '350px']}>
      Continue
    </Button>
  );
};
